import "./ChooseCash.scss";
import React, { useState } from "react";
import DynaInput from "../../../UI/DynaInput/DynaInput";
import RLookUpModal from "../RLookUpModal/RLookUpModal";
import {
  parseToEnRemoveComma,
  formatToPersianAddComma,
} from "../../../../utils/CommaSeparator";

const ChooseCash = ({
  sendData,
  setSendData,
  initialData,
  componentData,
  setComponentData,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="choose_bank_box">
      <button
        id="CashName"
        className="counterFactorBtn__"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        {sendData.currentSelectCashName === undefined
          ? "انتخاب صندوق"
          : sendData.currentSelectCashName}
      </button>
      <DynaInput
        label={"مبلغ پرداختی"}
        placeholder={"مبلغ را وارد کنید"}
        typeMode={"input"}
        type={"text"}
        className={"solid-login-type inputClass__"}
        value={formatToPersianAddComma(sendData.paidPrice)}
        onChange={(e) => {
          // Remove any non-numeric characters
          const enteredValue = parseToEnRemoveComma(e.target.value);
          const numericValue = enteredValue.replace(/[^0-9]/g, "");
          setSendData({ paidPrice: numericValue });
          setComponentData({ reload: Math.random() });
        }}
      />
      <>
        {isOpen && (
          <RLookUpModal
            id={initialData?.fundRLookUpId}
            callBackDataHandler={(incomingData) => {
              // console.log(incomingData);
              setSendData({
                // fund: {name: incomingData.na_176 },
                fund: incomingData.na_176,
                currentSelectCashName: incomingData.na_176,
              });
            }}
            modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}
          />
        )}
      </>
    </div>
  );
};

export default ChooseCash;
